import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgMedicalHead = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M5.83334 21.375V16.1542C4.68192 15.0875 3.8789 13.6984 3.52913 12.1683C3.17936 10.6382 3.29909 9.03813 3.8727 7.57712C4.44631 6.1161 5.44713 4.862 6.74448 3.97856C8.04184 3.09512 9.57543 2.6234 11.145 2.625C17.0942 2.625 18.3783 7.52334 20.4992 13.025C20.5355 13.1197 20.5483 13.2218 20.5364 13.3226C20.5245 13.4233 20.4883 13.5197 20.4309 13.6033C20.3735 13.6869 20.2966 13.7554 20.2069 13.8027C20.1172 13.85 20.0173 13.8748 19.9158 13.875H18.3333V16.375C18.3333 17.038 18.07 17.6739 17.6011 18.1428C17.1323 18.6116 16.4964 18.875 15.8333 18.875H14.5833V21.375"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.8334 9.5C15.8334 9.33424 15.7675 9.17527 15.6503 9.05806C15.5331 8.94085 15.3741 8.875 15.2084 8.875H13.3334V7C13.3334 6.83424 13.2675 6.67527 13.1503 6.55806C13.0331 6.44085 12.8741 6.375 12.7084 6.375H10.2084C10.0426 6.375 9.88364 6.44085 9.76643 6.55806C9.64922 6.67527 9.58337 6.83424 9.58337 7V8.875H7.70754C7.54192 8.87522 7.38317 8.94117 7.26614 9.05835C7.14911 9.17554 7.08337 9.33438 7.08337 9.5V12C7.08337 12.1658 7.14922 12.3247 7.26643 12.4419C7.38364 12.5592 7.54261 12.625 7.70837 12.625H9.58337V14.5C9.58337 14.6658 9.64922 14.8247 9.76643 14.9419C9.88364 15.0592 10.0426 15.125 10.2084 15.125H12.7084C12.8741 15.125 13.0331 15.0592 13.1503 14.9419C13.2675 14.8247 13.3334 14.6658 13.3334 14.5V12.625H15.2084C15.3741 12.625 15.5331 12.5592 15.6503 12.4419C15.7675 12.3247 15.8334 12.1658 15.8334 12V9.5Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgMedicalHead.displayName = 'SvgMedicalHead';
export default SvgMedicalHead;
